import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/app/[locale]/reviews/reviews.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dee7fca0d68e48/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomerReviewCard"] */ "/tmp/8dee7fca0d68e48/components/sections/CustomerReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GuestReviewCard"] */ "/tmp/8dee7fca0d68e48/components/sections/GuestReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerReviewsGrid"] */ "/tmp/8dee7fca0d68e48/components/sections/PartnerReviewsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewSection"] */ "/tmp/8dee7fca0d68e48/components/sections/ReviewSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8dee7fca0d68e48/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Container.module.css");
